/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import {useAccordionById} from '@amblique/contentful/app/contentful/hooks/use-accordion';
import {useAccordionPanelById} from '@amblique/contentful/app/contentful/hooks/use-accordion-panel';
import {useActionLinksById} from '@amblique/contentful/app/contentful/hooks/use-action-links';
import {useAuthorById} from '@amblique/contentful/app/contentful/hooks/use-author';
import {useAwardBlockById} from '@amblique/contentful/app/contentful/hooks/use-award-block';
import {useBlogById} from '@amblique/contentful/app/contentful/hooks/use-blog';
import {useBlogCategoryById} from '@amblique/contentful/app/contentful/hooks/use-blog-category';
import {useBlogGridById} from '@amblique/contentful/app/contentful/hooks/use-blog-grid';
import {useBlogListingById} from '@amblique/contentful/app/contentful/hooks/use-blog-listing';
import {useBlogRelatedArticlesById} from '@amblique/contentful/app/contentful/hooks/use-blog-related-articles';
import {useBreadcrumbById} from '@amblique/contentful/app/contentful/hooks/use-breadcrumb';
import {useCardById} from '@amblique/contentful/app/contentful/hooks/use-card';
import {useCarouselById} from '@amblique/contentful/app/contentful/hooks/use-carousel';
import {useCarouselItemById} from '@amblique/contentful/app/contentful/hooks/use-carousel-item';
import {useCategoryCardGridById} from '@amblique/contentful/app/contentful/hooks/use-category-card-grid';
import {useContainerById} from '@amblique/contentful/app/contentful/hooks/use-container';
import {useDescriptionBlockById} from '@amblique/contentful/app/contentful/hooks/use-description-block';
import {useEditorialCopyById} from '@amblique/contentful/app/contentful/hooks/use-editorial-copy';
import {useEditorialWrapperById} from '@amblique/contentful/app/contentful/hooks/use-editorial-wrapper';
import {useEmbedPanelById} from '@amblique/contentful/app/contentful/hooks/use-embed-panel';
import {useFeatureBlockById} from '@amblique/contentful/app/contentful/hooks/use-feature-block';
import {useFeatureListById} from '@amblique/contentful/app/contentful/hooks/use-feature-list';
import {useFeaturedInWithLogosCf052ById} from '@amblique/contentful/app/contentful/hooks/use-featured-in-with-logos-cf052';
import {useFooterById} from '@amblique/contentful/app/contentful/hooks/use-footer';
import {useFooterColumnById} from '@amblique/contentful/app/contentful/hooks/use-footer-column';
import {useFormBlockCf058ById} from '@amblique/contentful/app/contentful/hooks/use-form-block-cf058';
import {useGlobalConfigById} from '@amblique/contentful/app/contentful/hooks/use-global-config';
import {useHeaderById} from '@amblique/contentful/app/contentful/hooks/use-header';
import {useHeroBannerById} from '@amblique/contentful/app/contentful/hooks/use-hero-banner';
import {useHotspotContentById} from '@amblique/contentful/app/contentful/hooks/use-hotspot-content';
import {useIconById} from '@amblique/contentful/app/contentful/hooks/use-icon';
import {useIconSetById} from '@amblique/contentful/app/contentful/hooks/use-icon-set';
import {useImageById} from '@amblique/contentful/app/contentful/hooks/use-image';
import {useJobListingById} from '@amblique/contentful/app/contentful/hooks/use-job-listing';
import {useKingDifferenceBlockById} from '@amblique/contentful/app/contentful/hooks/use-king-difference-block';
import {useKingDifferenceMediaCf013ById} from '@amblique/contentful/app/contentful/hooks/use-king-difference-media-cf013';
import {useLinkById} from '@amblique/contentful/app/contentful/hooks/use-link';
import {useLoopingTickerById} from '@amblique/contentful/app/contentful/hooks/use-looping-ticker';
import {useMediaCarouselById} from '@amblique/contentful/app/contentful/hooks/use-media-carousel';
import {useMediaContentSectionById} from '@amblique/contentful/app/contentful/hooks/use-media-content-section';
import {useMediaWithScrollableTextById} from '@amblique/contentful/app/contentful/hooks/use-media-with-scrollable-text';
import {useMenuItemById} from '@amblique/contentful/app/contentful/hooks/use-menu-item';
import {useNavigationColumnById} from '@amblique/contentful/app/contentful/hooks/use-navigation-column';
import {useNavigationMenuById} from '@amblique/contentful/app/contentful/hooks/use-navigation-menu';
import {useNewBlogPostById} from '@amblique/contentful/app/contentful/hooks/use-new-blog-post';
import {usePageById} from '@amblique/contentful/app/contentful/hooks/use-page';
import {usePageContentById} from '@amblique/contentful/app/contentful/hooks/use-page-content';
import {useProductDetailById} from '@amblique/contentful/app/contentful/hooks/use-product-detail';
import {useProductListingById} from '@amblique/contentful/app/contentful/hooks/use-product-listing';
import {useProductTilesById} from '@amblique/contentful/app/contentful/hooks/use-product-tiles';
import {usePromoBannerById} from '@amblique/contentful/app/contentful/hooks/use-promo-banner';
import {usePromoBannerItemById} from '@amblique/contentful/app/contentful/hooks/use-promo-banner-item';
import {useRegionGeoModalById} from '@amblique/contentful/app/contentful/hooks/use-region-geo-modal';
import {useReviewItemById} from '@amblique/contentful/app/contentful/hooks/use-review-item';
import {useReviewsById} from '@amblique/contentful/app/contentful/hooks/use-reviews';
import {useRichTextBlockById} from '@amblique/contentful/app/contentful/hooks/use-rich-text-block';
import {useScrollableTextById} from '@amblique/contentful/app/contentful/hooks/use-scrollable-text';
import {useSearchById} from '@amblique/contentful/app/contentful/hooks/use-search';
import {useSectionPanelById} from '@amblique/contentful/app/contentful/hooks/use-section-panel';
import {useSectionPanelAldrinById} from '@amblique/contentful/app/contentful/hooks/use-section-panel-aldrin';
import {useSeoById} from '@amblique/contentful/app/contentful/hooks/use-seo';
import {useShopTheLookById} from '@amblique/contentful/app/contentful/hooks/use-shop-the-look';
import {useShopTheLookCustomById} from '@amblique/contentful/app/contentful/hooks/use-shop-the-look-custom';
import {useShowroomDetailsById} from '@amblique/contentful/app/contentful/hooks/use-showroom-details';
import {useSplitHeadingById} from '@amblique/contentful/app/contentful/hooks/use-split-heading';
import {useSplitPanelById} from '@amblique/contentful/app/contentful/hooks/use-split-panel';
import {useSplitPanelDoubleImageBlockById} from '@amblique/contentful/app/contentful/hooks/use-split-panel-double-image-block';
import {useSplitTextById} from '@amblique/contentful/app/contentful/hooks/use-split-text';
import {useSupportBlockById} from '@amblique/contentful/app/contentful/hooks/use-support-block';
import {useTeaserTileById} from '@amblique/contentful/app/contentful/hooks/use-teaser-tile';
import {useTeaserTileBlockById} from '@amblique/contentful/app/contentful/hooks/use-teaser-tile-block';
import {useTemplateStar1ById} from '@amblique/contentful/app/contentful/hooks/use-template-star1';
import {useTileById} from '@amblique/contentful/app/contentful/hooks/use-tile';
import {useUgcBlockById} from '@amblique/contentful/app/contentful/hooks/use-ugc-block';
import {useVideoById} from '@amblique/contentful/app/contentful/hooks/use-video';

/**
 * Type metadata map
 * Contains field names and hooks for each content type
 *
 * @typedef {Object} TypeMetadata
 * @property {string[]} fields - Array of field names for completeness checking
 * @property {Function} hook - React Query hook for fetching full data (useXById)
 *
 * @type {Record<string, TypeMetadata>}
 */
export const CONTENTFUL_METADATA = {
  Accordion: {
    fields: ['sys', 'body', 'sortOrder', 'title'],
    hook: useAccordionById,
  },
  AccordionPanel: {
    fields: ['sys', 'accordionsCollection', 'accordionsCursorCollection', 'isFaq', 'jumpLink', 'media', 'title'],
    hook: useAccordionPanelById,
  },
  ActionLinks: {
    fields: ['sys', 'description', 'displayStyle', 'linksCollection', 'linksCursorCollection', 'title'],
    hook: useActionLinksById,
  },
  Author: {
    fields: ['sys', 'bio', 'blogAuthorPhoto', 'name'],
    hook: useAuthorById,
  },
  AwardBlock: {
    fields: ['sys', 'jumpLink', 'leftContentCollection', 'leftContentCursorCollection', 'rightContentCollection', 'rightContentCursorCollection', 'title'],
    hook: useAwardBlockById,
  },
  Blog: {
    fields: ['sys', 'author', 'blogCategory', 'blogContent', 'blogHeaderMedia', 'blogTileImage', 'datePublished', 'description', 'duration', 'shareThisPostCollection', 'shareThisPostCursorCollection', 'title', 'url'],
    hook: useBlogById,
  },
  BlogCategory: {
    fields: ['sys', 'description', 'name', 'parentCategory', 'slug'],
    hook: useBlogCategoryById,
  },
  BlogGrid: {
    fields: ['sys', 'appearance', 'blogSummaryCollection', 'blogSummaryCursorCollection', 'cta', 'description', 'heading', 'jumpLink', 'title'],
    hook: useBlogGridById,
  },
  BlogListing: {
    fields: ['sys', 'filterTags', 'title'],
    hook: useBlogListingById,
  },
  BlogRelatedArticles: {
    fields: ['sys', 'blogTagsCollection', 'blogTagsCursorCollection', 'heading', 'title'],
    hook: useBlogRelatedArticlesById,
  },
  Breadcrumb: {
    fields: ['sys', 'jsonData', 'title'],
    hook: useBreadcrumbById,
  },
  Card: {
    fields: ['sys', 'appearance', 'badge', 'badgeBackgroundColor', 'badgeTextColor', 'category', 'customImage', 'description', 'jumpLink', 'lifestyleImage', 'primaryImage', 'productId', 'showColorOptions', 'showSizeOptions', 'title'],
    hook: useCardById,
  },
  Carousel: {
    fields: ['sys', 'blogTags', 'categoryId', 'description', 'einsteinRecommenderId', 'heading', 'productIds', 'title', 'viewAllLink'],
    hook: useCarouselById,
  },
  CarouselItem: {
    fields: ['sys', 'appearance', 'media', 'text1', 'text2', 'text3', 'text3Icon', 'text4', 'title'],
    hook: useCarouselItemById,
  },
  CategoryCardGrid: {
    fields: ['sys', 'cardItemsCollection', 'cardItemsCursorCollection', 'jumpLink', 'title'],
    hook: useCategoryCardGridById,
  },
  Container: {
    fields: ['sys', 'backgroundColour', 'fullWidth', 'region1Collection', 'region1CursorCollection', 'title'],
    hook: useContainerById,
  },
  DescriptionBlock: {
    fields: ['sys', 'content', 'heading', 'jumpLink', 'subHeading', 'title'],
    hook: useDescriptionBlockById,
  },
  EditorialCopy: {
    fields: ['sys', 'editorialCopy', 'jumpLink'],
    hook: useEditorialCopyById,
  },
  EditorialWrapper: {
    fields: ['sys', 'appearance', 'contentCollection', 'contentCursorCollection', 'title'],
    hook: useEditorialWrapperById,
  },
  EmbedPanel: {
    fields: ['sys', 'height', 'htmlContent', 'iframeUrl', 'jumpLink', 'mobileHeightIframe', 'scriptContent', 'separator', 'title', 'width'],
    hook: useEmbedPanelById,
  },
  FeatureBlock: {
    fields: ['sys', 'chooseContentsCollection', 'chooseContentsCursorCollection', 'jumpLink'],
    hook: useFeatureBlockById,
  },
  FeatureList: {
    fields: ['sys', 'columns', 'features', 'title'],
    hook: useFeatureListById,
  },
  FeaturedInWithLogosCf052: {
    fields: ['sys', 'heading', 'iconsCollection', 'iconsCursorCollection', 'jumpLink', 'quote', 'title'],
    hook: useFeaturedInWithLogosCf052ById,
  },
  Footer: {
    fields: ['sys', 'aboutUs', 'columnsCollection', 'columnsCursorCollection', 'countriesCollection', 'countriesCursorCollection', 'legalText', 'logo', 'paymentsCollection', 'paymentsCursorCollection', 'region', 'showroomFooter', 'siteId', 'siteNotes', 'socialLinksCollection', 'socialLinksCursorCollection'],
    hook: useFooterById,
  },
  FooterColumn: {
    fields: ['sys', 'linksCollection', 'linksCursorCollection', 'title'],
    hook: useFooterColumnById,
  },
  FormBlockCf058: {
    fields: ['sys', 'form', 'heading', 'jumpLink'],
    hook: useFormBlockCf058ById,
  },
  GlobalConfig: {
    fields: ['sys', 'accountGetInspired', 'accountHero', 'accountOrderHistoryFaq', 'accountShopNowLink', 'accountSuggestedForYou', 'availableRegions', 'cartPaymentIconsCollection', 'cartPaymentIconsCursorCollection', 'countriesCollection', 'countriesCursorCollection', 'loginImage', 'pdpPreferences', 'showroomHero', 'signUpHeader', 'signUpImage', 'siteId', 'siteName', 'socialLinksCollection', 'socialLinksCursorCollection'],
    hook: useGlobalConfigById,
  },
  Header: {
    fields: ['sys', 'headerStyle', 'logo', 'mainNavigation', 'promoBannersCollection', 'promoBannersCursorCollection', 'searchIdle', 'searchTyping', 'siteId', 'title', 'utilityLinksCollection', 'utilityLinksCursorCollection'],
    hook: useHeaderById,
  },
  HeroBanner: {
    fields: ['sys', 'appearance', 'backgroundColour', 'backgroundGradient', 'backgroundMedia', 'body', 'cta', 'enableScrollEffect', 'headingImage', 'headingTitle', 'jumpLink', 'rightCta', 'subtitle', 'textColour', 'title'],
    hook: useHeroBannerById,
  },
  HotspotContent: {
    fields: ['sys', 'image', 'mobileImage', 'mobileVideo', 'text', 'title', 'video'],
    hook: useHotspotContentById,
  },
  Icon: {
    fields: ['sys', 'description', 'iconImage', 'link', 'mediaType', 'name', 'svgCode', 'title'],
    hook: useIconById,
  },
  IconSet: {
    fields: ['sys', 'backgroundColour', 'explainerBlocksCollection', 'explainerBlocksCursorCollection', 'iconsCollection', 'iconsCursorCollection', 'jumpLink', 'maxItemsPerRowDesktop', 'textColour', 'title'],
    hook: useIconSetById,
  },
  Image: {
    fields: ['sys', 'alignment', 'altText', 'description', 'imageDescriptionContent', 'desktopAsset', 'fit', 'focus', 'format', 'height', 'mobileAsset', 'openInNewTab', 'quality', 'tabletAsset', 'title', 'url', 'width'],
    hook: useImageById,
  },
  JobListing: {
    fields: ['sys', 'title'],
    hook: useJobListingById,
  },
  KingDifferenceBlock: {
    fields: ['sys', 'content', 'heading', 'jumpLink', 'subHeading'],
    hook: useKingDifferenceBlockById,
  },
  KingDifferenceMediaCf013: {
    fields: ['sys', 'autoplay', 'jumpLink', 'mainImagesCollection', 'mainImagesCursorCollection', 'text1', 'text2', 'text3', 'thumbnailImagesCollection', 'thumbnailImagesCursorCollection', 'title'],
    hook: useKingDifferenceMediaCf013ById,
  },
  Link: {
    fields: ['sys', 'action', 'helptext', 'iconPosition', 'image', 'openInNewTab', 'popupContent', 'text', 'totalCount', 'linkType', 'url'],
    hook: useLinkById,
  },
  LoopingTicker: {
    fields: ['sys', 'backgroundColour', 'divider', 'enableAnimation', 'messages', 'pauseOnHover', 'textColour', 'title'],
    hook: useLoopingTickerById,
  },
  MediaCarousel: {
    fields: ['sys', 'appearance', 'autoPlay', 'body', 'description', 'imagesCollection', 'imagesCursorCollection', 'jumpLink', 'options', 'presets', 'thumbnailsCollection', 'thumbnailsCursorCollection', 'title', 'mediaCarouselType'],
    hook: useMediaCarouselById,
  },
  MediaContentSection: {
    fields: ['sys', 'backgroundColour', 'bodyCopy', 'heading', 'media', 'mediaAlignment', 'textColour', 'title'],
    hook: useMediaContentSectionById,
  },
  MediaWithScrollableText: {
    fields: ['sys', 'backgroundMedia', 'backgroundMediaMobile', 'jumpLink', 'scrollableTextCollection', 'scrollableTextCursorCollection', 'title'],
    hook: useMediaWithScrollableTextById,
  },
  MenuItem: {
    fields: ['sys', 'featuredLink', 'imagesCollection', 'imagesCursorCollection', 'link', 'submenuCollection', 'submenuCursorCollection', 'title', 'type'],
    hook: useMenuItemById,
  },
  NavigationColumn: {
    fields: ['sys', 'headerText', 'linksCollection', 'linksCursorCollection', 'title'],
    hook: useNavigationColumnById,
  },
  NavigationMenu: {
    fields: ['sys', 'menuItemsCollection', 'menuItemsCursorCollection', 'title'],
    hook: useNavigationMenuById,
  },
  NewBlogPost: {
    fields: ['sys', 'author', 'body', 'categories', 'featureImage', 'publishDate', 'relatedPostsCollection', 'relatedPostsCursorCollection', 'seo', 'seoDescription', 'seoTitle', 'slug', 'summary', 'tags', 'title'],
    hook: useNewBlogPostById,
  },
  Page: {
    fields: ['sys', 'categoryId', 'mainRegionCollection', 'mainRegionCursorCollection', 'pageType', 'productId', 'regions', 'seo', 'slug', 'storeId', 'title'],
    hook: usePageById,
  },
  PageContent: {
    fields: ['sys', 'bottomContentBlocksCollection', 'bottomContentBlocksCursorCollection', 'title', 'topContentBlocksCollection', 'topContentBlocksCursorCollection'],
    hook: usePageContentById,
  },
  ProductDetail: {
    fields: ['sys', 'customizeContent', 'customizeImageBackground', 'deliveryAvailabilityTooltip', 'kingGuardContent', 'kingGuardTitle', 'title', 'wantItSoonerContent', 'wantItSoonerHeading', 'wantItSoonerImage', 'warningMessageSwitchCustomizeMode'],
    hook: useProductDetailById,
  },
  ProductListing: {
    fields: ['sys', 'assemblyManual', 'filterTagAttributeIds', 'productCard', 'title'],
    hook: useProductListingById,
  },
  ProductTiles: {
    fields: ['sys', 'appearance', 'categoryId', 'cta', 'description', 'einsteinRecommenderId', 'heading', 'jumpLink', 'numberItemsPerView', 'productIDs', 'title'],
    hook: useProductTilesById,
  },
  PromoBanner: {
    fields: ['sys', 'backgroundColor', 'itemsCollection', 'itemsCursorCollection', 'textColor', 'title'],
    hook: usePromoBannerById,
  },
  PromoBannerItem: {
    fields: ['sys', 'link', 'promotionText', 'title'],
    hook: usePromoBannerItemById,
  },
  RegionGeoModal: {
    fields: ['sys', 'welcomeBody', 'welcomeHeading'],
    hook: useRegionGeoModalById,
  },
  ReviewItem: {
    fields: ['sys', 'description', 'heading', 'rating', 'title'],
    hook: useReviewItemById,
  },
  Reviews: {
    fields: ['sys', 'backgroundColour', 'heading', 'jumpLink', 'reviewsCollection', 'reviewsCursorCollection', 'starNavColour', 'textColour', 'title'],
    hook: useReviewsById,
  },
  RichTextBlock: {
    fields: ['sys', 'alignment', 'animation', 'appearance', 'content', 'image', 'jumpLink', 'quote', 'title'],
    hook: useRichTextBlockById,
  },
  ScrollableText: {
    fields: ['sys', 'body', 'heading', 'title'],
    hook: useScrollableTextById,
  },
  Search: {
    fields: ['sys', 'articleTags', 'popularSearches', 'title', 'trendingProductIds'],
    hook: useSearchById,
  },
  SectionPanel: {
    fields: ['sys', 'appearance', 'contentCollection', 'contentCursorCollection', 'jumpLink', 'paddingBottom', 'paddingTop', 'title'],
    hook: useSectionPanelById,
  },
  SectionPanelAldrin: {
    fields: ['sys', 'appearance', 'contentCollection', 'contentCursorCollection', 'paddingBottom', 'paddingTop', 'title'],
    hook: useSectionPanelAldrinById,
  },
  Seo: {
    fields: ['sys', 'description', 'keywords', 'ogImage', 'title'],
    hook: useSeoById,
  },
  ShopTheLook: {
    fields: ['sys', 'heading', 'hotspots', 'hotspotsContentCollection', 'hotspotsContentCursorCollection', 'imageUrl', 'jumpLink', 'mobileImageUrl', 'shopTheLookButtonLabel', 'showShopButtonLabelDesktop', 'showShopButtonLabelMobile', 'showShopTheLookButton', 'shopTheLookRichText', 'title', 'shopTheLookTypes'],
    hook: useShopTheLookById,
  },
  ShopTheLookCustom: {
    fields: ['sys', 'content', 'hotspots', 'productId', 'title'],
    hook: useShopTheLookCustomById,
  },
  ShowroomDetails: {
    fields: ['sys', 'contactFormDescription', 'countries', 'description', 'featuredImage', 'headerBlock', 'jumpLink', 'name', 'onDisplayCollection', 'onDisplayCursorCollection', 'parkingAddress', 'relatedPages', 'seo', 'storeId', 'storeImages', 'supportBlock', 'wheelchairAccessible'],
    hook: useShowroomDetailsById,
  },
  SplitHeading: {
    fields: ['sys', 'headingLeftSize', 'jumpLink', 'textLeft', 'textRight', 'title'],
    hook: useSplitHeadingById,
  },
  SplitPanel: {
    fields: ['sys', 'leftContent', 'ratio', 'rightContent', 'style', 'title'],
    hook: useSplitPanelById,
  },
  SplitPanelDoubleImageBlock: {
    fields: ['sys', 'contentCollection', 'contentCursorCollection', 'jumpLink', 'mediaPosition', 'primaryImage', 'title'],
    hook: useSplitPanelDoubleImageBlockById,
  },
  SplitText: {
    fields: ['sys', 'headingLeftSize', 'headingRightFontSize', 'textLeft', 'textRight'],
    hook: useSplitTextById,
  },
  SupportBlock: {
    fields: ['sys', 'actionsCollection', 'actionsCursorCollection', 'description', 'image', 'jumpLink', 'title'],
    hook: useSupportBlockById,
  },
  TeaserTile: {
    fields: ['sys', 'descriptionCollection', 'descriptionCursorCollection', 'image', 'link', 'openInNewTab', 'teaserText', 'title'],
    hook: useTeaserTileById,
  },
  TeaserTileBlock: {
    fields: ['sys', 'appearance', 'jumpLink', 'teaserTilesCollection', 'teaserTilesCursorCollection', 'title'],
    hook: useTeaserTileBlockById,
  },
  TemplateStar1: {
    fields: ['sys', 'template1'],
    hook: useTemplateStar1ById,
  },
  Tile: {
    fields: ['sys', 'description', 'image', 'title'],
    hook: useTileById,
  },
  UgcBlock: {
    fields: ['sys', 'bannerId', 'jumpLink', 'title'],
    hook: useUgcBlockById,
  },
  Video: {
    fields: ['sys', 'options', 'presets', 'title', 'videoAsset', 'videoIdOrUrl'],
    hook: useVideoById,
  },
};
